import React from 'react';
import cx from 'classnames';
import { Menu } from '@jjj/components';
import MainMenuWrapper from './mainMenu.style';

const MainMenu = ({ items, collapsed, openKeys, current, onOpenChange, onClick }) => {
  return (
    <MainMenuWrapper>
      <Menu
        onClick={onClick}
        theme="dark"
        className={cx('isoDashboardMenu', { 'ant-menu-inline-collapsed': collapsed })}
        mode="inline"
        openKeys={openKeys}
        selectedKeys={current}
        onOpenChange={onOpenChange}
        items={items}
      />
    </MainMenuWrapper>
  );
};

export default MainMenu;
